var map = {
	"./Linz_Blumen_Pflanzen.svg": 4627,
	"./Linz_Brot_Gebaeck.svg": 5212,
	"./Linz_Cafe.svg": 250,
	"./Linz_Cafe_Konditorei_Mehlspeisen.svg": 5523,
	"./Linz_Date_Check.svg": 1072,
	"./Linz_Deko_und_Geschenksartikel_Handelswaren.svg": 7059,
	"./Linz_Dienstleistungen.svg": 1304,
	"./Linz_Drogerie_Reformartikel.svg": 7043,
	"./Linz_Fleisch_Wurst_Gefluegel_Fisch.svg": 7056,
	"./Linz_Gastro.svg": 4974,
	"./Linz_Imbiss.svg": 9411,
	"./Linz_Internationale_Spezialitaeten.svg": 8212,
	"./Linz_Lebensmittel.svg": 1338,
	"./Linz_Obst_Gemuese.svg": 2581,
	"./magnifier.svg": 978,
	"./shopkart.svg": 3863
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5813;